import React from 'react';
import { FlameIcon, ShieldCheckIcon, WavesIcon } from 'lucide-react';
import { PRODUCT_PRICE, formatPrice } from '../data/config';
import { offerItems } from '../data/content';
import { CheckItem } from './CheckItem';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type OfferSectionProps = {
  showReferencePrices: boolean;
  guaranteeEnabled: boolean;
};
export function OfferSection({
  guaranteeEnabled
}: OfferSectionProps) {
  return <section id="offer" className="scroll-mt-2 bg-white px-4 py-6 text-center md:px-12 md:py-8" data-id="element-127" data-mp="mejsu6oje9pv">
      <p className="font-heading text-[11px] font-bold uppercase tracking-[0.3em] text-goldDark md:text-[12px]" data-id="element-128" data-mp="re678jg3pw09">
        Special launch offer
      </p>

      <div className="mx-auto mt-1.5 max-w-[512px] rounded-lg border-2 border-gold bg-surface px-3 pb-4 pt-3 md:px-4" data-id="element-129" data-mp="wchimym1oekl">
        <h2 className="font-heading text-[24px] font-extrabold uppercase leading-[1.1] tracking-[-0.3px] text-navy md:text-[30px]" data-id="element-130" data-mp="2t7dz0scwi631">
          <WavesIcon className="mr-1.5 inline h-6 w-6 -translate-y-0.5 text-brand" strokeWidth={2.5} aria-hidden data-id="element-131" data-mp="12o1ucztcaw6g" />
          AQUA CLASS HUB™
        </h2>
        <p className="mx-auto mt-1 max-w-[420px] font-heading text-[11px] font-bold uppercase leading-[1.35] text-brand md:text-[12px]" data-id="element-132" data-mp="xvh4uahgv58q">
          The complete ready-to-teach class collection for aqua fitness instructors.
        </p>

        <div className="mx-auto mt-2.5 max-w-[200px]" data-id="element-133" data-mp="1lm4dwz34c0wv">
          <ProductImage data-id="element-134" data-mp="1llup3ett7zsr" />
        </div>

        <p className="mt-2 font-heading text-[13px] font-extrabold uppercase text-navy md:text-[14px]" data-id="element-135" data-mp="1gn9ubuxbu8bp">
          Complete 6-in-1 system
        </p>
        <ul className="mx-auto mt-1.5 max-w-[400px] text-left text-[14px] leading-[1.5] text-ink md:text-[15px]" data-id="element-136" data-mp="1ckdci6fm2g8t">
          {offerItems.map(item => <CheckItem key={item} data-id="element-137" data-mp="169ij090ws3r">{item}</CheckItem>)}
        </ul>

        <p className="mt-3 flex items-center justify-center gap-1.5 font-heading text-[14px] font-extrabold uppercase leading-tight text-navy md:text-[16px]" data-id="element-138" data-mp="146hll6c1ek9">
          <FlameIcon className="h-4 w-4 shrink-0 fill-flameFill text-flame" strokeWidth={2} aria-hidden data-id="element-139" data-mp="3tvauc4bu9ed7" />
          Get your aqua classes ready today!
        </p>
        <p className="mt-1 font-heading text-[46px] font-extrabold leading-none tracking-[-1px] text-gold md:text-[54px]" data-id="element-140" data-mp="3ktl2ixe1odew">
          {formatPrice(PRODUCT_PRICE)} <span className="text-[18px] tracking-normal text-navy md:text-[20px]" data-id="element-141" data-mp="3ot3dp1g2da4j">USD</span>
        </p>

        <div className="mt-2.5" data-id="element-142" data-mp="3b270ahupkzi2">
          <CtaButton mode="checkout" subtext="Instant digital access" className="max-w-none min-h-[64px]" data-id="element-143" data-mp="3ftyfjw8ezisw">
            Get instant access
          </CtaButton>
        </div>

        {guaranteeEnabled && <p className="mx-auto mt-2.5 max-w-[420px] font-heading text-[11px] font-bold uppercase leading-snug text-navy md:text-[12px]" data-id="element-144" data-mp="3645dpmy2qi1u">
            <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-brand" aria-hidden data-id="element-145" data-mp="2s5yth9m1sgkn" />
            7-day money-back guarantee <span className="text-gold" data-id="element-146" data-mp="2x5jqhehnqeuq">•</span> 6 volumes + 5 free bonuses
          </p>}
      </div>
    </section>;
}